import z from "zod";
export const DTOForgeMemoryEntry = z.object({
    id: z.string().uuid(),
    projectId: z.string(),
    text: z.string(),
    category: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
    metadata: z.record(z.string()).optional(),
});
/**
 * Schema that defines a single memory entry create input
 */
export const DTOForgeMemoryCreateInput = z.object({
    projectId: z.string(),
    text: z.string(),
    category: z.string(),
    metadata: z.record(z.string()).optional(),
});
/**
 * Schema that defines a single memory entry update input
 */
export const DTOForgeMemoryUpdateInput = z.object({
    id: z.string().uuid(),
    text: z.string().optional(),
    category: z.string(),
    metadata: z.record(z.string()).nullish(),
});
/**
 * Schema that defines a single memory entry delete input
 */
export const DTOForgeMemoryDeleteInput = z.object({
    id: z.string().uuid(),
});
/**
 * Response containing a list of memory entries (can be empty array)
 */
export const DTOForgeMemoryEntryListResponse = z.object({
    memoryEntries: DTOForgeMemoryEntry.array(),
});
/**
 * Response containing a single memory entry
 */
export const DTOForgeMemoryEntryResponse = z.object({
    memoryEntry: DTOForgeMemoryEntry,
});
/**
 * Properties used to list memory entries
 */
export const DTOForgeMemoryEntryListQuery = z.object({
    projectId: z.string(),
});
